import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';

export interface ImageryRequestDto {
  level: 'FIELD' | 'FARM' | 'TENANT';
  targetId: number;
  fileType: string;
  dateFrom?: string;  // YYYY-MM-DD format - start of date range
  dateTo?: string;    // YYYY-MM-DD format - end of date range
  // Deprecated - use dateFrom/dateTo instead
  daysBack?: number;
  historicalDate?: string;
}

export interface ImageryRequestResponse {
  id: number;
  level: string;
  targetId: number;
  fileType: string;
  dateFrom: string | null;
  dateTo: string | null;
  daysBack: number | null;
  historicalDate: string | null;
  requestedByUserId: number;
  status: 'NEW' | 'PROCESSING' | 'COMPLETE' | 'FAILED';
  errorMessage: string | null;
  fieldsTotal: number | null;
  fieldsCompleted: number | null;
  totalHectares: number | null;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class ImageryRequestService extends BaseService {

  // Use the polaris management API endpoint
  // For AllFarm: api-staging.yaraallfarm.com/v2/polaris
  // This will need to be configured per environment
  private readonly IMAGERY_API_URL = environment['imageryApiUrl'] || (this.API_BASE_URL + 'polaris-management');

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Request new satellite imagery processing
   */
  requestImagery(request: ImageryRequestDto): Observable<ImageryRequestResponse> {
    return this.httpClient.post<ImageryRequestResponse>(
      `${this.IMAGERY_API_URL}/imagery/request`,
      request
    );
  }

  /**
   * Get status of a specific imagery request
   */
  getRequestStatus(requestId: number): Observable<ImageryRequestResponse> {
    return this.httpClient.get<ImageryRequestResponse>(
      `${this.IMAGERY_API_URL}/imagery/request/${requestId}`
    );
  }

  /**
   * Get all imagery requests for the current user
   */
  getMyRequests(): Observable<ImageryRequestResponse[]> {
    return this.httpClient.get<ImageryRequestResponse[]>(
      `${this.IMAGERY_API_URL}/imagery/requests`
    );
  }
}
